import React from 'react'
import AuthCenterContext from './AuthCenterContext'

export default function withAuthCenter () {
    return (Component) => (props) => (
        <AuthCenterContext.Consumer>
            {auth => <Component authCenter={auth} {...props} />}
        </AuthCenterContext.Consumer>
    )
}